import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCreate = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M19.9998 11.1112V18.2222C19.9998 19.2045 19.2042 20 18.222 20H5.77775C4.79554 20 4 19.2045 4 18.2222V5.77797C4 4.79577 4.79554 4.00022 5.77775 4.00022H12.8888M19.4122 6.58785C20.013 5.98704 20.0251 5.02512 19.4394 4.43933C18.8536 3.85355 17.8916 3.86572 17.2908 4.46653L9.02313 12.7342C8.42232 13.335 7.53986 15.1673 8.12565 15.753C8.71143 16.3388 10.5436 15.4564 11.1444 14.8556L19.4122 6.58785Z",
		stroke: "#111827",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgCreate);
export default ForwardRef;
